import React from 'react';
import ReactDOM from 'react-dom';
import BaseFeature from 'foundation/base/base';
import GameButtons from './GameButtons';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { store, persistor } from 'app/shared/store';
import { HashRouter, Route, Switch } from 'react-router-dom';

class GameOverviewButtons extends BaseFeature {
  constructor(element) {
    super(element);
    this.isInit = false;
    this.init();
    this.path = '/';
  }

  init() {
    if (!this.isInit) {
      this.isInit = true;

      this.loadReactApp();
    }
  }

  loadReactApp() {
    ReactDOM.render(
      <>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <HashRouter>
              <Switch>
                <Route>
                  <GameButtons {...this.settings} />
                </Route>
              </Switch>
            </HashRouter>
          </PersistGate>
        </Provider>
      </>, this.element);
  }
}

export default GameOverviewButtons;